import React, { useContext } from "react";
import { FooterContext } from "../../../../store/context/footer-context";
import Category from "./Category";
import "./index.scss";

const Navigation = () => {
  const { navigationData } = useContext(FooterContext);
  return (
    <div className="GCL-F-N">
      {navigationData.map((data, index) => (
        <Category key={index} index={index} {...data} />
      ))}
    </div>
  );
};

export default Navigation;
